import { render, staticRenderFns } from "./site-nav-category.vue?vue&type=template&id=bf4b035a&"
import script from "./site-nav-category.vue?vue&type=script&lang=js&"
export * from "./site-nav-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports